import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { Alert, AlertType } from '../components/alert/alert';

@Injectable()
export class AlertService {
    private subject: Subject<Alert> = new Subject<Alert>();
    private delete: Subject<Alert> = new Subject<Alert>();

    private keepAfterRouteChange = false;

    constructor(private router: Router) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                // only keep for a single route change
                if (this.keepAfterRouteChange) this.keepAfterRouteChange = false;
                // clear alert messages
                else this.clear();
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }
    removeAlert(): Observable<any> {
        return this.delete.asObservable();
    }

    success(message: string, keepAfterRouteChange = false, timeout: number = 2000) {
        this.alert(AlertType.Success, message, keepAfterRouteChange, timeout);
    }

    error(message: string, keepAfterRouteChange = false, timeout: number = 5000) {
        this.alert(AlertType.Error, message, keepAfterRouteChange, timeout);
    }

    info(message: string, keepAfterRouteChange = false, timeout: number = 3000) {
        this.alert(AlertType.Info, message, keepAfterRouteChange, timeout);
    }

    warn(message: string, keepAfterRouteChange = false, timeout: number = 4000) {
        this.alert(AlertType.Warning, message, keepAfterRouteChange, timeout);
    }

    alert(type: AlertType, message: string, keepAfterRouteChange: boolean = false, timeout: number = undefined) {
        this.keepAfterRouteChange = keepAfterRouteChange;

        const alert: Alert = { type: type, message: message };
        this.subject.next(alert);
        if (timeout) setTimeout((alert: Alert) => { this.delete.next(alert); }, timeout, alert);
    }

    clear() {
        // clear alerts
        this.subject.next();
    }
}
